import React from 'react';

import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { DownArrowIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

import {
  ResponsiveSearchDrawerItemContent,
  ResponsiveSearchDrawerItemText,
  ResponsiveSearchDrawerItemTitle,
  ResponsiveSearchDrawerItemSubtitle,
} from './ResponsiveListingSearchStyle';
interface ResponsiveDrawerInterface {
  icon:
    | React.FunctionComponent<
        React.SVGProps<SVGSVGElement> | CustomIconComponentProps
      >
    | React.ComponentClass<
        React.SVGProps<SVGSVGElement> | CustomIconComponentProps,
        any
      >
    | undefined;

  title: string;
  subTitle: string;
  arrowIcon: boolean;
  onClick:
    | ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void)
    | undefined;

  className?: string;
  error?: boolean;
  isFilled?: boolean;
}

const ResponsiveSearchDrawerItem: React.FC<ResponsiveDrawerInterface> = ({
  icon,
  title,
  subTitle,
  arrowIcon,
  onClick,
  className,
  error,
  isFilled,
}) => {
  const onKeyPress = (e: any): void => {
    const enterOrSpace =
      e.key === 'Enter' ||
      e.key === ' ' ||
      e.key === 'Spacebar' ||
      e.which === 13 ||
      e.which === 32;
    if (enterOrSpace) {
      e.preventDefault();
      if (onClick) onClick(e);
    }
  };

  return (
    <ResponsiveSearchDrawerItemContent
      onKeyPress={onKeyPress}
      role='button'
      tabIndex={-1}
      onClick={onClick}
      className={className}
      hasError={error || false}
    >
      <CustomIcon icon={icon} fontSize={28} paletteColor='primaryBrand' />
      <ResponsiveSearchDrawerItemText>
        <ResponsiveSearchDrawerItemTitle isFilled={isFilled}>
          {title}
        </ResponsiveSearchDrawerItemTitle>
        <br />
        <ResponsiveSearchDrawerItemSubtitle isFilled={isFilled}>
          {subTitle}
        </ResponsiveSearchDrawerItemSubtitle>
      </ResponsiveSearchDrawerItemText>

      {arrowIcon && <CustomIcon fontSize={16} icon={DownArrowIcon} />}
    </ResponsiveSearchDrawerItemContent>
  );
};

export default ResponsiveSearchDrawerItem;
